/**
 * 支付模块常量定义
 */

export enum PaymentMethodEnum {
  PAYPAL = 3,
  STRIPE = 4,
}

export const PAYMENT_METHOD_NAMES: Record<number, string> = {
  [PaymentMethodEnum.PAYPAL]: 'paypal',
  [PaymentMethodEnum.STRIPE]: 'stripe',
}

export const PAYMENT_METHOD_PAY_TYPES: Record<number, number> = {
  [PaymentMethodEnum.PAYPAL]: 6,
  [PaymentMethodEnum.STRIPE]: 5,
}

export const TOPUP_API_ENDPOINTS: Record<number, string> = {
  [PaymentMethodEnum.PAYPAL]: '/member/topup/createPaypalPaymentIntent',
  [PaymentMethodEnum.STRIPE]: '/member/topup/createStripePaymentIntent',
}

export const SUBSCRIBE_API_ENDPOINT = '/member/subscribe/createOrder'

export const PRODUCT_LIST_API = {
  TOPUP: '/member/topup/v2/product/list',
  SUBSCRIBE: '/member/subscribe/v2/product/list',
}

// 订阅周期枚举值（对齐 H5 src/utils/enum.ts SubscriptionCycle）
export const SubscriptionCycleValue = {
  WEEK: 1,
  MONTH: 2,
  SEASON: 3,
  HALF_YEAR: 4,
  YEAR: 5,
  ThreeDays: 6,
}

// VIP 类型（对齐 H5 src/constants.ts VIP_TYPE）
export const VIP_TYPE = {
  NORMAL: 0,
  DISCOUNT: 1,
}
